export const URL_PARAM_TO_DCS_PARAM: Readonly<Record<string, string>> = {
  q: "query",
  tab: "type",
  attributes: "subjects",
  subject: "subjects",
  "skills.skill": "skills",
  "skillsData.skill": "skills",
  productType: "productType",
  learning_type: "productType",
  "aiLanguages.translationLanguages": "aiLanguages.translationLanguages",
  "ai_languages.translation_languages": "aiLanguages.translationLanguages",
};

export const mapSearchParamToDcs = (key: string): string =>
  URL_PARAM_TO_DCS_PARAM[key] ?? key;

interface SearchParamsIterable {
  forEach: (callback: (value: string, key: string) => void) => void;
}

export const mapSearchParamsToDcs = (
  searchParams: SearchParamsIterable,
): URLSearchParams => {
  const mappedSearchParams = new URLSearchParams();

  searchParams.forEach((value, key) => {
    mappedSearchParams.append(mapSearchParamToDcs(key), value);
  });

  return mappedSearchParams;
};
